import { render, staticRenderFns } from "./VehicleSetup.vue?vue&type=template&id=5b9f27b7&"
import script from "./VehicleSetup.vue?vue&type=script&lang=js&"
export * from "./VehicleSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports